import cookie from 'vux/src/tools/cookie/index.js'

const TokenKey = 'Token'

export function getToken () {
return cookie.get(TokenKey)
}

export function setToken (token) {
return cookie.set(TokenKey, token, {
path: '/',
expires: 1
})
}

export function removeToken () {
return cookie.remove(TokenKey, {
path: '/'
})
}



// WEBPACK FOOTER //
// ./src/auth/auth.js